import { useEffect, PropsWithChildren } from "react";
import clsx from "clsx";
import { twMerge } from "tailwind-merge";

import { useCommonStore } from "@stores/index";

export const Drawer = ({
  className,
  children,
}: {
  className?: string;
} & PropsWithChildren) => {
  const setCommonState = useCommonStore(({ setState }) => setState);

  useEffect(() => {
    document.body.style.overflowY = "hidden";
    setCommonState({ isDrawerShown: true });

    return () => {
      document.body.style.removeProperty("overflow-y");
    };
  }, [setCommonState]);

  return (
    <div
      className="fixed inset-0 z-20 flex items-center justify-center bg-black-54 md:justify-end"
      data-testid="drawer"
    >
      <div
        className={twMerge(
          clsx("min-h-dvh w-full bg-white-100 md:w-[760px]", className),
        )}
      >
        {children}
      </div>
    </div>
  );
};
